/**
 * @generated SignedSource<<55b6c6e689662829b38c23d47a75e5f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveUsersFromAccountInput = {
  clientMutationId?: string | null;
  userIds: ReadonlyArray<string>;
};
export type removeMemberModal_RemoveUsersFromAccountInputMutation$variables = {
  connections: ReadonlyArray<string>;
  input: RemoveUsersFromAccountInput;
};
export type removeMemberModal_RemoveUsersFromAccountInputMutation$data = {
  readonly AccountMemberManagement: {
    readonly removeUsersFromAccount: {
      readonly removedIds: ReadonlyArray<string>;
    } | null;
  };
};
export type removeMemberModal_RemoveUsersFromAccountInputMutation = {
  response: removeMemberModal_RemoveUsersFromAccountInputMutation$data;
  variables: removeMemberModal_RemoveUsersFromAccountInputMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "removeMemberModal_RemoveUsersFromAccountInputMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementMutations",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RemoveUsersFromAccountPayload",
            "kind": "LinkedField",
            "name": "removeUsersFromAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "removeMemberModal_RemoveUsersFromAccountInputMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementMutations",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RemoveUsersFromAccountPayload",
            "kind": "LinkedField",
            "name": "removeUsersFromAccount",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "removedIds",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6da19eb8f68fbb7b65fef178f133d97b",
    "id": null,
    "metadata": {},
    "name": "removeMemberModal_RemoveUsersFromAccountInputMutation",
    "operationKind": "mutation",
    "text": "mutation removeMemberModal_RemoveUsersFromAccountInputMutation(\n  $input: RemoveUsersFromAccountInput!\n) {\n  AccountMemberManagement {\n    removeUsersFromAccount(input: $input) {\n      removedIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b18f8a1f93175d91388c710c60b593f";

export default node;
